import React from "react";
import { StaticQuery, graphql, Link } from "gatsby";
import { linkFormat } from "../utilities/linkFormat";

const resolveBlockTypeAsComponent = (blockType) => {
  // logic that maps a block type ("DatoCmsFooterSectionLink") to a React component and returns is
  switch (blockType) {
    case "DatoCmsFooterSection":
      return ListItemHeading;
    case "DatoCmsFooterSectionLink":
      return ListItem;
    case "DatoCmsSocialMediaIcon":
      return FollowIcon;
    case "DatoCmsCallToAction":
      return CtaButton;
    default:
      <li></li>;
  }
};

const ListItemHeading = (props) => (
  <li className="text-primary font-bold font-a1 pb-5 uppercase">
    {props.heading}
  </li>
);

const ListItem = (props) => {
  if (props.linkUrl.startsWith("/")) {
    return (
      <li>
        <Link to={props.linkUrl} className="text-sm pb-5 block">
          <span className="hds-text-color font-normal">{props.linkText}</span>
        </Link>
      </li>
    );
  }
  return (
    <li>
      <a href={linkFormat(props.linkUrl) || "#"} className="text-sm pb-5 block">
        {props.linkText}
      </a>
    </li>
  );
};

const FollowIcon = (props) => (
  <li className="inline-block bg-thermaBlue rounded-full mr-1">
    <a
      href={props.linkUrl || "#"}
      className="flex flex-col h-8 w-8 justify-center items-center"
    >
      <div
        className={`${props.iconType}-icon follow-icon min-h-4`}
        role="img"
        aria-label={props.iconType}
      />
    </a>
  </li>
);

const CtaButton = (props) => (
  <li>
    <a
      href={linkFormat(props.buttonLinkUrl)}
      className="block mt-6 font-heading"
    >
      <button className="fg-btn fg-btn--blue">{props.buttonText}</button>
    </a>
  </li>
);

const FooterFactory = ({ data }) => {
  const { footerContent } = data;
  let footerSections = [];
  let currentSection = [];
  footerContent.forEach((footerBlock) => {
    if (
      currentSection.length &&
      footerBlock.internal.type === "DatoCmsFooterSection"
    ) {
      footerSections.push(currentSection);
      currentSection = Object.create([]);
      currentSection.push(footerBlock);
    } else {
      currentSection.push(footerBlock);
    }
  });
  footerSections.push(currentSection);
  return (
    <footer className="Footer hds-container hds-text-color bg-extra-light-blue">
      <section className="hds-section">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 w-full">
          {footerSections.map((blockData, i) => (
            <ul
              className={i !== 5 ? "flex flex-col" : "col-span-2"}
              key={blockData[0].id}
            >
              {blockData.map((footerBlock) => {
                const BlockComponent = resolveBlockTypeAsComponent(
                  footerBlock.internal.type
                );
                return <BlockComponent {...footerBlock} key={footerBlock.id} />;
              })}
            </ul>
          ))}
        </div>
        <div className="hds-legal md:block text-center mt-md">
          <p>
            {`©${new Date().getFullYear()}. All rights reserved. `}
            <Link to="/pages/legal-privacy">Legal and Privacy</Link>
          </p>
        </div>
      </section>
    </footer>
  );
};

export default function Footer(props) {
  const locale = props.locale || "en";
  return (
    <StaticQuery
      query={graphql`
        query FooterQuery {
          allDatoCmsFooter {
            nodes {
              footerContent {
                ... on DatoCmsFooterSection {
                  id
                  heading
                  internal {
                    type
                  }
                }
                ... on DatoCmsFooterSectionLink {
                  id
                  linkText
                  linkUrl
                  internal {
                    type
                  }
                }
                ... on DatoCmsSocialMediaIcon {
                  id
                  linkUrl
                  iconType
                  internal {
                    type
                  }
                }
                ... on DatoCmsCallToAction {
                  id
                  buttonText
                  buttonLinkUrl
                  buttonColor {
                    rgb
                  }
                  internal {
                    type
                  }
                }
              }
              locale
            }
          }
        }
      `}
      // can't pass a variable into StaticQuery nor use string-interpolation in graphql queries so we have to get a little creative
      render={(data) => (
        <FooterFactory
          data={
            data.allDatoCmsFooter.nodes.filter(
              (node) => node.locale === locale
            )[0]
          }
          {...props}
        />
      )}
    />
  );
}
